// Polyfills for Android 4.4 / iOS 9 compatibility
// Proxy & AbortController polyfills must be loaded before @tanstack/react-query
import "proxy-polyfill/proxy.min.js";
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "whatwg-fetch";
import "promise-polyfill/src/polyfill";

import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "antd-mobile/es/global";
import AppRouter from "./router/index";
import "./utils/rem";
import "./utils/report";
import "./index.less";
import { isSdicHomeApp, showVConsole } from "./utils/utils";
import { isSit, isLocal } from "./config/env";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { ErrorBlock } from "antd-mobile";
import { useEffect, useState } from "react";

if (isSdicHomeApp() && (isSit || isLocal)) {
  showVConsole();
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      notifyOnChangeProps: "all", // 跳过 trackResult() 的 Proxy 包裹，兼容低版本 WebView
    },
  },
});

function Fallback(props: FallbackProps) {
  const [errorMessage, setErrorMessage] = useState("");
  const [errorStack, setErrorStack] = useState("");
  useEffect(() => {
    setErrorMessage((props.error as any)?.message);
    setErrorStack((props.error as any)?.stack);
  }, [props.error]);
  return (
    <div>
      <ErrorBlock description={errorMessage} status="busy">
        <div className="mt-24px flex items-center justify-center text-[14px]">
          <p>{errorMessage}</p>
          <p>{errorStack}</p>
        </div>
      </ErrorBlock>
    </div>
  );
}

const container: Element | DocumentFragment = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <ErrorBoundary FallbackComponent={Fallback}>
    <QueryClientProvider client={queryClient}>
      <Router basename={process.env.PUBLIC_URL}>
        <AppRouter />
      </Router>
    </QueryClientProvider>
  </ErrorBoundary>
);
